import React from "react";
import UserList from "../Table/UserList";

const CustomerList = () => {
  return <UserList userRole={3} userType={"customer"} />;
};

export default CustomerList;
